<template>
    <div class="main--content container">
        <div class="row">
            <div class="col-12">
                <job-index-search
                    ref="job_index_search"
                    :search="search"
                    :show_filter="show_filter"
                    :sort_by="sort_by"
                    v-on:new-data="setJobsData"
                    v-on:getting-data="showLoader"
                ></job-index-search>
            </div>
        </div>

        <!-- If the page is getting new data -->
        <div v-if="loader">
            <div class="loader"></div>
        </div>
        <!-- If the server provided data -->
        <div v-else-if="jobs">
            <!-- If the data is empty -->
            <div v-if="jobs.length === 0">
                <p>No jobs found</p>
            </div>

            <!-- Display the jobs -->
            <div class="row" v-else v-for="job in jobs" v-bind:key="job.id">
                <job-row-card
                    :job="job"
                    :show_url="show_url"
                ></job-row-card>
            </div>

            <pagination v-if="data" :data="data" @pagination-change-page="getResults" />
        </div>
    </div>
</template>

<script>
import pagination from 'laravel-vue-pagination';
import JobIndexSearch from "../jobs/JobIndexSearch";
import JobRowCard from "../jobs/JobRowCard";

export default {
    name: "JobIndex",
    components: {JobIndexSearch, JobRowCard, pagination},
    props: [
        'show_filter',
        'sort_by',
        'search',
        'show_url',
    ],

    data() {
        return {
            data: null,
            jobs: null,
            loader: false,
        };
    },

    mounted() {
        this.getResults();
    },

    methods: {
        setJobsData(res) {
            this.data = res.jobs;
            this.jobs = res.jobs.data;
        },

        getResults(page = 1) {
            this.$refs.job_index_search.submit(page);
        },

        showLoader(show) {
            this.loader = show;
        },
    },

}
</script>

